import React from 'react'
import { Table, Dropdown } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const LocationTable = ({
    appId,
    address,
    createdAt,
    refClients,
    clientOpts,
    onRefClientsChange,
    loading
}) => {
    return (
        <Table style={{ marginBottom: '20px' }} definition>
            <Table.Body>

                <Table.Row>
                    <Table.Cell width={5}>Valvonta</Table.Cell>
                    <Table.Cell textAlign="left">
                        <Link to={`/admin/kohteet/${appId}/valvonta`}>Avaa</Link>
                    </Table.Cell>
                </Table.Row>

                <Table.Row>
                    <Table.Cell width={5}>Application ID</Table.Cell>
                    <Table.Cell textAlign="left">{appId}</Table.Cell>
                </Table.Row>

                <Table.Row>
                    <Table.Cell width={5}>Osoite</Table.Cell>
                    <Table.Cell textAlign="left">{address}</Table.Cell>
                </Table.Row>

                <Table.Row>
                    <Table.Cell width={5}>Luotu</Table.Cell>
                    <Table.Cell textAlign="left">{createdAt}</Table.Cell>
                </Table.Row>

                <Table.Row>
                    <Table.Cell width={5}>Asiakas</Table.Cell>
                    <Table.Cell>
                        <Dropdown
                            fluid
                            selection
                            options={clientOpts}
                            value={refClients}
                            loading={loading}
                            onChange={(e, data) => onRefClientsChange(appId, data.value)}
                        />
                    </Table.Cell>
                </Table.Row>

            </Table.Body>
        </Table>
    )
}

LocationTable.propTypes = {
    appId: PropTypes.string,
    address: PropTypes.string,
    createdAt: PropTypes.string,
    refClients: PropTypes.number,
    clientOpts: PropTypes.array,
    onRefClientsChange: PropTypes.func,
    loading: PropTypes.bool
}

export default LocationTable


// WEBPACK FOOTER //
// ./src/Admin/Locations/LocationsList/LocationTable.js